import i18n from '../../../../../i18n';
import { clearH5TokenAfterNewOpen } from '../../../../../stores/user';

export const Successful = () => {
  return (
    <div class="padding-x-L margin-y-XL">
      <div class="flex align-center flex-column" style={{ 'margin-bottom': '80px' }}>
        <svg width="60" height="60" viewBox="0 0 60 60" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_338_1020)">
            <path
              d="M0 30C0 37.9565 3.16071 45.5871 8.7868 51.2132C14.4129 56.8393 22.0435 60 30 60C37.9565 60 45.5871 56.8393 51.2132 51.2132C56.8393 45.5871 60 37.9565 60 30C60 22.0435 56.8393 14.4129 51.2132 8.7868C45.5871 3.16071 37.9565 0 30 0C22.0435 0 14.4129 3.16071 8.7868 8.7868C3.16071 14.4129 0 22.0435 0 30Z"
              fill="#46DD93"
            />
            <path
              d="M24.0851 41.2626C24.4844 41.7021 25.0413 41.9659 25.6343 41.9965C26.2273 42.0272 26.8083 41.8221 27.2508 41.4261L27.3543 41.3286L42.8538 25.5786C43.2633 25.1625 43.4951 24.6034 43.5 24.0196C43.505 23.4357 43.2828 22.8728 42.8804 22.4498C42.4779 22.0267 41.9269 21.7767 41.3435 21.7524C40.7601 21.7282 40.1902 21.9317 39.7541 22.3199L39.6468 22.4219L25.8153 36.4761L19.6653 29.7059C19.2807 29.2824 18.7492 29.0214 18.179 28.9758C17.6087 28.9303 17.0425 29.1036 16.5956 29.4606L16.4876 29.5529C16.0639 29.9375 15.8027 30.4692 15.7571 31.0396C15.7116 31.61 15.8851 32.1764 16.2423 32.6234L16.3346 32.7314L24.0851 41.2626Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_338_1020">
              <rect width="60" height="60" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <div class="color-D font-s-L margin-t-L font-bold">{i18n.OpenProgress.Offline.SuccessTitle}</div>
      </div>
      <div class="flex justify-space-between">
        <div>{i18n.OpenProgress.Offline.LocationLabel}</div>
        <div class="color-D">{i18n.OpenProgress.Offline.LocationValue}</div>
      </div>
      <div class="flex justify-space-between margin-t-L">
        <div>{i18n.OpenProgress.Offline.TimeLabel}</div>
        <div class="color-D">{i18n.OpenProgress.Offline.TimeValue}</div>
      </div>

      <div class="bg-c-D round padding color margin-t-XL">
        {i18n.OpenProgress.Offline.SuccessNote}
        <span class="link-color">{i18n.OpenProgress.Offline.CancelReservation}</span>
      </div>

      <button
        class="primary-btn btn-rounded margin-t-XXL"
        style={{ width: '100%' }}
        onclick={() => {
          (window as any).ReactNativeWebView?.postMessage(
            JSON.stringify({
              type: 'WEB_TO_APP_FINISHOPEN',
              payload: 'WEB_TO_APP_FINISHOPEN',
            })
          );
          clearH5TokenAfterNewOpen();
        }}
      >
        {i18n.OpenProgress.Common.Done}
      </button>
    </div>
  );
};
